/**
 * Errors Clear Subcommand
 */
import { Command } from 'commander';
import { confirm } from '@inquirer/prompts';
import { ErrorLogService } from '../../services/error-log.service.js';

interface ClearOptions {
  all?: boolean;
  id?: string;
  yes?: boolean;
}

export function createErrorsClearSubcommand(): Command {
  return new Command('clear')
    .description('Xoá error logs')
    .option('--all', 'Delete all error logs')
    .option('--id <id>', 'Delete one error log by id')
    .option('-y, --yes', 'Skip confirmation')
    .action(async (options: ClearOptions) => {
      const service = new ErrorLogService();
      const paths = await service.list();

      if (paths.length === 0) {
        console.log('✨ Không có error logs nào để xoá.');
        return;
      }

      if (options.all) {
        if (!(options.yes || (await confirm({ message: 'Xoá tất cả error logs?', default: false })))) {
          console.log('❌ Đã huỷ.');
          return;
        }
        await service.clear(paths);
        console.log(`✅ Đã xoá ${paths.length} error logs.`);
        return;
      }

      if (!options.id) {
        console.error('❌ Vui lòng dùng --id <id> hoặc --all.');
        process.exit(1);
      }

      const targetPath = paths.find((p) => p.endsWith(`${options.id}.json`));
      if (!targetPath) {
        console.error(`❌ Không tìm thấy log: ${options.id}`);
        process.exit(1);
      }

      if (!(options.yes || (await confirm({ message: `Xoá log ${options.id}?`, default: false })))) {
        console.log('❌ Đã huỷ.');
        return;
      }

      await service.clear([targetPath]);
      console.log(`✅ Đã xoá log ${options.id}.`);
    });
}
